// ---- Importing required dependencies (External)——
// ---- Packages ----
import styled from "styled-components";

// Exporting Styles for Button
export const Button = styled.div`
  /* Section 1: Styling */
  position: fixed;
  width: 100%;
  left: calc(8% - 6.5%);
  transform: translateX(-100%);
  bottom: 80px;
  height: 20px;
  font-size: 3rem;
  z-index: 100;
  cursor: pointer;
  color: #be9e57;

  /* Section 2: Responsive styles */
  @media only screen and (max-width: 900px) {
    /* Nested styles for screen width <= 900px */
    left: calc(5%);
    bottom: 70px;
  }
`;
